<template>
  <div
    class="i-navbar-item"
    :class="{ active: props.isActive }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <slot name="icon"> </slot>

    <div class="text">
      {{ props.text }}
    </div>

    <div
      v-if="props.isDropdownItem"
      class="dropdown-chevron"
    >
      <img
        v-if="props.useMoreIcon"
        class="chevron"
        :src="isHovered ? iconMoreActive : iconMore"
        alt="Dropdown chevron"
      />
      <img
        v-else
        class="chevron"
        :src="isHovered ? iconDropdownChevronActive : iconDropdownChevron"
        alt="Dropdown chevron"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue"

// Assets
import iconDropdownChevronActive from "@/assets/menu/icon-dropdown-chevron-active.svg"
import iconDropdownChevron from "@/assets/menu/icon-dropdown-chevron.svg"
import iconMoreActive from "@/assets/menu/icon-more-active.svg"
import iconMore from "@/assets/menu/icon-more.svg"

const props = defineProps({
  isDropdownItem: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  },
  useMoreIcon: {
    type: Boolean,
    default: false
  }
})

// Reactive state to track hover
const isHovered = ref(false)

// Event handlers to update hover state
const handleMouseEnter = () => {
  isHovered.value = true
}

const handleMouseLeave = () => {
  isHovered.value = false
}
</script>

<style scoped lang="scss">
.i-navbar-item {
  @include flex(row, center, center, $gap: 8px);

  padding: 4px;
  height: 32px;
  cursor: pointer;
  color: $black900;

  &:hover,
  &.active {
    color: $azure-radiance500;
  }

  .text {
    @include text-lg;

    font-weight: 500;
  }
}
</style>
